import React from 'react';
import classnames from 'classnames';

import { SignalVariant } from '../types';
import styles from './status-badge.module.scss';
import { Icon, IconProps } from '../icon';
import { Text } from '../text';

type Size = 'small' | 'medium' | 'large';

export type StatusBadgeProps = {
  labelText?: string;
  className?: string;
  iconAriaHidden?: boolean;
  iconAriaLabel?: string;
  iconName?: IconProps['name'];
  labelPosition?: 'horizontal' | 'vertical';
  signal: SignalVariant;
  size: Size;
};

const baseClass = 'status-badge';

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  labelText,
  className,
  iconName,
  iconAriaHidden,
  iconAriaLabel,
  labelPosition,
  size,
  signal
}) => {
  const containerClasses = classnames(styles[baseClass], styles[`${baseClass}--${labelPosition}`], className);
  const circleClasses = classnames(
    styles[`${baseClass}__circle`],
    styles[`${baseClass}__circle--${signal}`],
    styles[`${baseClass}__circle--${size}`]
  );
  const getTextVariant = (badgeSize: Size) => {
    switch (badgeSize) {
      case 'small':
        return 'caption-300-fixed';
      case 'medium':
        return 'caption-200-fixed';
      default:
        return 'caption-100';
    }
  };

  return (
    <div className={containerClasses} data-testid="statusbadge-component">
      <div className={circleClasses}>
        {iconName && (
          <Icon
            name={iconName}
            aria-label={iconAriaLabel}
            aria-hidden={iconAriaHidden}
            className={styles[`${baseClass}__icon`]}
          />
        )}
      </div>
      {labelText && (
        <div className={styles[`${baseClass}__label`]}>
          <Text variant={getTextVariant(size)}>{labelText}</Text>
        </div>
      )}
    </div>
  );
};
